import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=62c42b72&scoped=true&"
import script from "./addCustom.vue?vue&type=script&lang=js&"
export * from "./addCustom.vue?vue&type=script&lang=js&"
import style0 from "./addCustom.vue?vue&type=style&index=0&id=62c42b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c42b72",
  null
  
)

component.options.__file = "addCustom.vue"
export default component.exports